import axios from "axios";
import { graphql } from "gatsby";
import { useStaticQuery } from "gatsby";
import { navigate } from "gatsby";
import React, { useEffect, useState } from "react";
import './gravityForm.css'

export default function GravityForm({id, colorClass, submitFunc, objectTitel}){

    const data = useStaticQuery(graphql`
        query AllPagesQuery{
            allWpPage{
                edges{
                    node{
                        slug
                        databaseId
                    }
                }
            }
        }`)

    const [form, setForm] = useState()
    const [submitted, setSubmitted] = useState(false)
    const [error, setError] = useState()
    const [message, setMessage] = useState()
    const [entryId, setEntryId] = useState()

    useEffect(()=>{
        const token = btoa(`${process.env.GATSBY_GF_KEY}:${process.env.GATSBY_GF_SECRET}`)

        axios.get(`${process.env.GATSBY_GF_ENDPOINT}/forms/${id}`, {
            headers: {
                'Authorization': `Basic ${token}` 
              }
        }).then((res)=>{
            setForm(res.data)
        })
    }, [])

    useEffect(()=>{

        const formObj = form !== undefined ?  Object.values(form?.confirmations)[0] : null
        const token = btoa(`${process.env.GATSBY_GF_KEY}:${process.env.GATSBY_GF_SECRET}`)

        if(submitted){
            axios.post(`${process.env.GATSBY_GF_ENDPOINT}/entries/${entryId}/notifications`, {

            } , {
                headers: {
                    'Authorization': `Basic ${token}` 
                  }
            }).then((res)=>{
                 if(formObj?.type == 'message' && res.status == 200){
                    setMessage(formObj?.message)
                }else if(formObj?.type == 'page' && res.status == 200){
                    let page = data.allWpPage.edges.filter((p)=> p.node.databaseId == formObj?.pageId)
                    navigate(`/${page[0].node.slug}/`)
                }
            })
        }

    },[submitted])

    useEffect(()=>{
        if(entryId !== undefined){
            setSubmitted(true)
            if(submitFunc !== undefined){
                submitFunc(true)
            }
        }
    },[entryId])

    const fields = form?.fields

    const submitHandler = (e) => {
        e.preventDefault()

        const token = btoa(`${process.env.GATSBY_GF_KEY}:${process.env.GATSBY_GF_SECRET}`)
        const date = new Date()

        const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`

        let postData = {
            "form_id"      : id,
            "date_created" : dateString,
            "created_by"   : 1,
            "status"       : "active",
        }
        
        let data = {}

        for (let i = 0; i < fields.length; i++) {
            let id = e.target[i].id
            let val = e.target[i].value 

            data[id] = val
        }

        axios.post(`${process.env.GATSBY_GF_ENDPOINT}/entries`, {
            ...postData,
            ...data
        } , {
            headers: {
                'Authorization': `Basic ${token}` 
              }
        }).then((res)=>{
            res.status == 201 ? 
                // setSubmitted(true)
                setEntryId(res.data.id)
            : setError('Er is iets mis gegaan, probeer het nog eens.')
        })
    }


    return(
        <div className="gfForm">
            {!submitted && fields !== undefined ? 
                <form onSubmit={submitHandler}>
                    {
                        fields?.map((f)=>{
                            return(
                                <div className="flex flex-col mb-4 relative">
                                    {f.labelPlacement !== 'hidden_label' && f.type !=='hidden' ? <label className="mb-2 text-base " htmlFor={f.id}>{f.label}{f.isRequired ? <span>*</span> : ''}</label> : null }
                                    {f.type !== 'textarea' && f.type !== 'select' && f.type !== 'hidden' && f.type ? <input className={`px-4 py-2 ${colorClass ? colorClass : 'bg-white'}`} placeholder={f.placeholder} type={f.type !== 'phone' ? f.type : 'tel'} id={f.id} required={f.isRequired ? 'required' : ''}  ></input> : f.type == 'textarea' ? <textarea className={`h-32 px-4 py-2 ${colorClass ? colorClass : 'bg-white'}`} placeholder={f.placeholder} id={f.id}></textarea> : f.type == 'select' ? <select className={`px-4 py-2 ${colorClass ? colorClass : 'bg-white'}`} placeholder={f.placeholder}>{f.choices.map((c)=> <option value={c.value}>{c.text}</option> )}</select> : f.type == 'hidden' && objectTitel !== undefined ? <input className={`px-4 py-2 ${colorClass ? colorClass : 'bg-white'}`} placeholder={f.placeholder} type={f.type !== 'phone' ? f.type : 'tel'} id={f.id} required={f.isRequired ? 'required' : ''} value={objectTitel} ></input> :null}
                                </div>
                            )
                        })
                    }
                    <input type="submit" value={form?.button.text} className="bg-red px-5 py-3 text-white cursor-pointer button"></input>
                </form>
            : submitted && message !== undefined ?
                <p>
                    {message}
                </p>
            : !submitted && error !== undefined ?
                <p>
                    {error}
                </p>
            : 

                <div className="">
                    <div className="flex flex-col mb-4">
                        <div className="animated-label animated-background mb-2"></div>
                        <div className="w-full animated-background"></div>
                    </div>
                    <div className="flex flex-col mb-4">
                        <div className="animated-label animated-background mb-2"></div>
                        <div className="w-full animated-background"></div>
                    </div>
                    <div className="flex flex-col mb-4">
                        <div className="animated-label animated-background mb-2"></div>
                        <div className="w-full animated-background"></div>
                    </div>
                    <div className="flex flex-col mb-4">
                        <div className="animated-label animated-background mb-2"></div>
                        <div className="w-full animated-background animated-textarea"></div>
                    </div>
                    <div className="animated-submit animated-background mb-2"></div>
                </div>

            }
        </div>
    )
}
